import React from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

import URLRange from "../components/URLs";
import { createURLLinkObject } from "../utils/objectCreaters";
import IDynamicFormRow from "../yoello-lib/modules/dynamicForms/interfaces/IDynamicFormRow";
import { VenueLinks } from "../utils/objectCreaters";
import FormTextBox from "../yoello-lib/modules/dynamicForms/FormComponents/FormTextBox";
import DynamicFormExtender from "../yoello-lib/modules/dynamicForms/DynamicFormExtender";
import FormTitle from "../yoello-lib/modules/dynamicForms/FormComponents/FormTitle";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    p: {
      fontSize: "1.07143rem",
      color: "#8D98B7",
      lineHeight: "1.7143rem",
    },
  })
);

export const urlsForm = (t: (key: string) => string): IDynamicFormRow[] => {
  return [
    {
      label: "",
      Component: () => {
        const classes = useStyles();

        return (
          <>
            <p className={classes.p}>{t("links.custom1")}</p>
            <p className={classes.p}>{t("links.custom2")}</p>
          </>
        );
      },
      keyName: "",
    },
    {
      label: "",
      Component: () => {
        return <FormTitle title={t("links.optionalLinks")} />;
      },
      keyName: "",
    },
    {
      label: "forms.details.venueWebsite",
      keyName: "url_website",
      Component: FormTextBox,
      inputProperties: {
        type: "url",
      },
      gridColumnOptions: {
        formCol: 6,
      },
    },
    {
      label: "forms.details.venueFacebook",
      keyName: "url_facebook",
      Component: FormTextBox,
      inputProperties: {
        type: "url",
      },
      gridColumnOptions: {
        formCol: 6,
      },
    },
    {
      label: "forms.details.venueInstagram",
      keyName: "url_instagram",
      Component: FormTextBox,
      inputProperties: {
        type: "url",
      },
      gridColumnOptions: {
        formCol: 6,
      },
    },
    {
      label: "forms.details.venueTwitter",
      keyName: "url_twitter",
      Component: FormTextBox,
      inputProperties: {
        type: "url",
      },
      gridColumnOptions: {
        formCol: 6,
      },
    },
    {
      Component: DynamicFormExtender,
      label: "links.customLinks",
      keyName: "custom_links",
      registerOptions: {
        validate: (links: VenueLinks) => {
          if (links === undefined || links === null) {
            return true;
          }
          for (const [key, link] of Object.entries(links)) {
            /**If both links & label are empty we're gonna delete */
            if (link.url.length === 0 && link.label.length === 0) {
              delete links[key];
              break;
            }
            if (link.url.length === 0 || link.label.length === 0) {
              return false;
            }
          }
          return true;
        },
      },
      formProps: {
        Component: URLRange,
        createNewObjectFunction: createURLLinkObject,
        buttonLabel: "merchant.buttons.newurl",
        requireEntry: false,
        startWithEntry: false,
      },
    },
  ];
};
